import styled from 'styled-components';

import { Flex } from '@/components/base';
import ToggleRadio from '@/components/Common/ToggleRadio';
import Typo from '@/components/Typography/Typo';

import type { DiscordChannelT } from '../types/types';

type Props = {
  channel: DiscordChannelT;
  isActive: boolean;
  onChangeActive: (c: DiscordChannelT) => void;
};

const DiscordWorkspaceChannelItem = (props: Props) => {
  return (
    <ItemStyle d="column" style={{ width: '45%' }} g="8px">
      <Flex j="space-between">
        <Flex g="4px" a="center">
          <Typo type="label2">{props.channel.name}</Typo>
        </Flex>
        <ToggleRadio
          status={props.isActive}
          onChange={() => props.onChangeActive(props.channel)}
        />
      </Flex>
    </ItemStyle>
  );
};

export default DiscordWorkspaceChannelItem;

const ItemStyle = styled(Flex)`
  padding: 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
`;
